// Product completeness only: recognition, cut-off and valuation have separate checks.
// Mirrored in the classic-script client, with behavioral parity tests.
const buildYearClosingSales = ({ state = {}, year, scope }: any): any => {
  const list = (value: any): any[] => Array.isArray(value) ? value : []
  const date = (value: any): string => {
    const raw = String(value || '').trim()
    const local = raw.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
    const iso = local ? `${local[3]}-${local[2]}-${local[1]}` : raw.slice(0, 10)
    return /^\d{4}-\d{2}-\d{2}$/.test(iso) && !Number.isNaN(Date.parse(iso)) && new Date(iso).toISOString().slice(0, 10) === iso ? iso : ''
  }
  const supported = scope?.jurisdiction === 'NO' && ['partial', 'supported'].includes(scope?.productSupport) && Number.isInteger(year) && year >= 1900 && year <= 2200
  const documents: any[] = []
  const add = (entry: any, source: string) => {
    if (['annulled', 'reversed', 'deleted'].includes(entry.status)) return
    const kind = source === 'invoice' ? entry.kind || 'invoice' : 'otherSale'
    if (source === 'invoice' && !['invoice', 'credit'].includes(kind)) return
    const iso = date(entry.date)
    if (iso && iso.slice(0, 4) !== String(year)) return
    const number = String(entry.invoiceNumber || entry.number || entry.documentNumber || entry.voucherNumber || '')
    const incomplete = source === 'invoice' ? !number || !list(entry.lines).length
      : !String(entry.description || '').trim() && !entry.attachmentId && !list(entry.attachments).length
    const issue = !iso ? 'undated' : entry.status === 'draft' ? 'draft' : incomplete ? 'incomplete' : null
    const send = list(entry.sendEvents).slice(-1)[0]
    // Latest persisted delivery matches the existing invoice-delivery model.
    // Sending is follow-up, not proof of revenue recognition or payment.
    const followUp = source !== 'invoice' || issue ? null : ['bounced', 'failed', 'complained'].includes(String(send?.deliveryStatus || ''))
      ? 'deliveryFailed' : !entry.sentAt ? 'unsent' : null
    documents.push({ id: String(entry.id || ''), source, kind, date: iso, number, name: entry.customer?.name || entry.customerName || entry.description || number || '', issue, followUp })
  }
  list(state.invoices).forEach((entry) => add(entry, 'invoice'))
  list(state.otherSales).forEach((entry) => add(entry, 'otherSale'))
  documents.sort((a, b) => a.date.localeCompare(b.date) || a.source.localeCompare(b.source) || a.id.localeCompare(b.id))
  const issues = documents.filter((row) => row.issue)
  const followUps = documents.filter((row) => row.followUp)
  const blockers = [...new Set(issues.map((row) => row.issue))]
  if (!supported) blockers.unshift('unsupported')
  return { year, supported, documents, issues, followUps, blockers, count: issues.length || (supported ? 0 : 1), status: blockers.length ? 'todo' : 'ok', reason: !supported ? 'unsupported' : issues.length ? 'pending' : followUps.length ? 'followUp' : 'ready' }
}

window.PlummeYearClosingSales = { build: buildYearClosingSales }
